import useIsMobile from "../../hooks/useIsMobile";
import MobileNav from "./MobileNav";
import Nav from "./Nav";

const NavLayout = ({ children }: { children: React.ReactNode }) => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <>
        <MobileNav />
        {children}
      </>
    );
  }

  return (
    <>
      <Nav />
      {children}
    </>
  );
};

export default NavLayout;
